import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { encodeQueryString } from '~/src/common/utilities';
import { ArticlesIcon } from '~/src/components';
import { LocalizedLink } from '~/src/components/content-templates/MetaInfo';
import { breakpoints, turquoise } from '~/src/styles';

export const StyleLevelContainer = styled.div`
  grid-area: style-level;
  display: flex;
  color: ${turquoise};
  gap: 8px;
  display: flex;
  align-items: center;
`;
export const LinksGroup = styled.div`
  line-height: 16px;
  color: white;
`;

const linkStyles = css({
  fontFamily: 'Montserrat',
  fontSize: '12px',
  fontWeight: '400',
  letterSpacing: '0.1em',
  textAlign: 'left',
  color: 'white',
  textTransform: 'uppercase',
  [breakpoints.minDesktop]: {
    fontSize: '16px',
  },
});

interface Props {
  content: {
    topic: {
      name: string;
    };
    channel: {
      name: string;
    };
  };
}

export const RelatedLinks: React.FC<Props> = ({ content }) => {
  const {
    topic: { name: topicName },
  } = content;

  return (
    <StyleLevelContainer>
      <ArticlesIcon style={{ height: '20px', color: turquoise }} />
      <LinksGroup>
        <LocalizedLink to={`/articles/?topic=${encodeQueryString(topicName)}`} css={linkStyles}>
          {topicName}
        </LocalizedLink>
      </LinksGroup>
    </StyleLevelContainer>
  );
};
